import { useTranslation } from 'react-i18next'

import ErrorImage from 'shared/images/error_handler.png'
import { PopupContent } from 'shared/ui/poup-content'

interface Props {
  onCloseDirection?: () => void
}

export const InfoSameDirection = ({ onCloseDirection }: Props) => {
  const { t } = useTranslation()

  return (
    <PopupContent
      button={t('continue')}
      image={ErrorImage}
      title={t('same_flight')}
      description={t('same_flight_des')}
      onClick={onCloseDirection}
    />
  )
}
